import axiosInstance from "../helpers/axiosInstance"

export const installShopifyStore = async (store_id, shopify_state) => {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/channel_integrations/shopify/install`, {store_id, shopify_state})
    return res.data
}